
import { getCurrentInstance, onMounted, ref, toRefs, reactive } from 'vue'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Button from 'primevue/button'
import Paginator from '@/views/components/paginator/Paginator.vue'
import ProgressSpinner from 'primevue/progressspinner'
import InputIconRight from '@/views/components/form/InputIconRight.vue'
import HjpConfirmationModal from '@/views/components/modal/HjpConfirmationModal.vue'
import { useStore } from 'vuex'
import apiUseCase from '@/usecase/apiUseCase'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import moment from 'moment'
import CloseRitDialog from './CloseRitDialog.vue'

export default {
  components: {
    DataTable,
    Column,
    Paginator,
    Button,
    ProgressSpinner,
    InputIconRight,
    HjpConfirmationModal,
    // CloseRitDialog
  },
  props: {
    ritList: {
      default: () => []
    }
  },
  emits: ['showCloseRitDialog', 'reloadHeader'],
  setup(props: any, { emit }: any) {
    const transactionControlEndpoint = '/transaction/v1/Control'
    const app = getCurrentInstance()
    const {
      $icon, $toast
    } = app!.appContext.config.globalProperties
    const icon = $icon
    const { ritList } = toRefs(props)
    const store = useStore()
    const inputSearch = ref('')
    const selectedRitId = ref(null) as any
    const showCloseRitDialog = ref(false)
    const selectedConrollerData = ref(null) as any
    const dataSource = ref([]) as any
    const filters = {
      search: '',
      filterField: ['controllerName'] as any,
      pageSize: 10,
      pageNumber: 1,
      custom: [] as any,
      totalRecords: 0
    }

    const attrModalConfirmation = reactive({
      show: false,
      title: 'Turunkan Kontroler?',
      subTitle: 'Pastikan kontroler yang akan Anda turunkan sudah benar-benar keluar dari bus!',
      btnSubmitTitle: 'Turunkan Kontroler',
      imgContent: require('@/assets/img/modal-confirmation/dropoff-controller.svg')
    })

    const getAllRitTicketData = async () => {
      store.dispatch('showLoading')
      await apiUseCase.get(`${transactionControlEndpoint}${returnUrlPrams(filters)}`).then((response) => {
        const {
          error,
          result,
          count
        } = response
        if (!error) {
          // console.log('result', result)
          dataSource.value = result
          filters.totalRecords = count
        }
      })
      store.dispatch('hideLoading')
    }

    const selectedRitAct = (id: any) => {
      filters.pageNumber = 1
      if (selectedRitId.value === id) {
        selectedRitId.value = null
        filters.custom = []
      } else {
        selectedRitId.value = id
        filters.custom = [['ritId', '=', selectedRitId.value]]
        getAllRitTicketData()
      }
    }

    const onSearch = () => {
      filters.pageNumber = 1
      filters.search = inputSearch.value
      getAllRitTicketData()
    }

    const onChangePage = (val: any) => {
      filters.pageNumber = val.page + 1
      getAllRitTicketData()
    }

    const showCloseRitDialogAct = (id: any) => {
      emit('showCloseRitDialog', id)
    }

    const dropOffControllerAct = async () => {
      store.dispatch('showLoading')
      const payload = {
        DropoffStationName: selectedConrollerData.value?.BoardStationName,
        DropoffVerbatim: 'Diturunkan oleh Admin'
      }
      try {
        await apiUseCase.postWithNoId(`${transactionControlEndpoint}/${selectedConrollerData.value.Id}/Checkout`, payload).then((response) => {
          const { error, message } = response
          if (!error) {
            $toast.add({
              severity: 'success',
              detail: 'Kontroler berhasil diturunkan',
              group: 'bc',
              closable: false,
              life: 3000
            })
            // eslint-disable-next-line no-use-before-define
            hidedropOffController()
            getAllRitTicketData()
            selectedConrollerData.value = null
          } else {
            $toast.add({
              severity: 'error',
              summary: 'Kontroler gagal diturunkan',
              detail: message,
              group: 'bc',
              closable: false,
              life: 3000
            })
          }
        })
      } catch (error) {
        $toast.add({
          severity: 'error',
          summary: 'Kontroler gagal diturunkan',
          detail: error,
          group: 'bc',
          closable: false,
          life: 3000
        })
      }
      store.dispatch('hideLoading')
    }

    const showdropOffController = (data: any) => {
      selectedConrollerData.value = data
      attrModalConfirmation.show = true
    }

    const hidedropOffController = () => {
      selectedConrollerData.value = null
      attrModalConfirmation.show = false
    }

    return {
      icon,
      inputSearch,
      getAllRitTicketData,
      onSearch,
      ritList,
      dataSource,
      selectedRitId,
      selectedRitAct,
      filters,
      onChangePage,
      moment,
      attrModalConfirmation,
      showdropOffController,
      hidedropOffController,
      dropOffControllerAct,
      showCloseRitDialogAct,
      showCloseRitDialog,
    }
  }
}
